import { IReturn, JsonServiceClient } from "@servicestack/client";
import { SWRConfiguration } from "swr";
import { useMemo } from "react";
import useSwrClient from "./useSwrClient";


import { SWRResponse } from "swr";

export interface IPostConfiguration<T, D, E, A> {
    getData?: (response?: SWRResponse<T, T>) => D | undefined;
    getError?: (response?: SWRResponse<T, T>) => E | undefined;
    getAdditionalState?: (response?: SWRResponse<T, T>) => A | undefined;
}

export const usePost = <T, D, E, A extends object>(fn?: () => IReturn<T>, getConfiguration?: IPostConfiguration<T, D, E, A>, swrConfiguration?: SWRConfiguration | undefined, fetcherFn?: (client: JsonServiceClient, request: IReturn<T> | null) => Promise<T> | null) => {
    const { post } = useSwrClient();
    const response = post<T>(fn, swrConfiguration, fetcherFn);

    const { getData, getError, getAdditionalState } = getConfiguration ?? {};

    const result = useMemo(() => {
        const d = getData?.(response);
        const e = getError?.(response);
        const a = getAdditionalState?.(response);

        const s = {
            data: d,
            error: e,
            loading: response.isValidating && !d && !e,
            validating: response.isValidating,
            mutate: response.mutate,
            refresh: async () => {
                const newResponse = await response.mutate(response.data, { revalidate: true })

                return getData?.(newResponse as any);
            }
        }

        return {
            ...s,
            ...a
        } as typeof s & A

    }, [getData, getError, response.data, response.error, response.isLoading, response.isValidating, response.mutate]);

    return result;
};

export default usePost;